var map = {
	"./charge-point-icon.svg": "e624",
	"./cog-icon-copy.svg": "b1b1",
	"./globe-icon.svg": "0548",
	"./group.svg": "8a3b",
	"./guide-icon-copy.svg": "0f8b",
	"./menu-arrow-down.svg": "20c6",
	"./negative-icon.svg": "124a",
	"./positive-icon.svg": "50c9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";